import Vue from 'vue'
import date from './date'
import isNaN from 'lodash/isNaN'

const {
  formateDateRange,
  formateMonthRange,
  formatePeriodRange,
  relativeTimeFormat,
  relativeYearFormat
} = date

// 精确至date时间段显示
Vue.filter('dateRangeFormate', formateDateRange)

// 精确至month时间段显示
Vue.filter('monthRangeFormate', formateMonthRange)

// 精确至上下旬时间段显示
Vue.filter('periodRangeFormate', formatePeriodRange)

// 与当前时间的相对时间
Vue.filter('relativeTimeFormat', relativeTimeFormat)
// 与当前日期的相对日期（年）
Vue.filter('relativeYearFormat', relativeYearFormat)
// 数字补0
Vue.filter('fullNumber', value => {
  let number = Number(value)
  if (isNaN(number)) {
    return value
  } else {
    return number > 9 ? number : `0${number}`
  }
})

/**
 * 文件类型格式化，多个文件类型按照顺序 显示前 len 个
 * @param value 		传进来的文件类型数组
 * @param len	 		取前面几个类型拼接，默认为2
 * @param return
 */
Vue.filter('joinFileType', (value, len = 2, join = '+') => {
  let ext = ''
  if (
    value &&
    Object.prototype.toString.call(value) === '[object Array]' &&
    value.length
  ) {
    // 先排序
    let sorted = []

    // 排序依据
    const SORT_DIC = ['mp4', 'ppt', 'pdf', 'img']

    // 排序之后的文件列表
    // 这个地方不仅仅是排序，还需要记住原来的index，用于索引文件
    const tmp = value
      .map((value, index) => {
        return { item: value, index }
      })
      .sort((a, b) => {
        let aIndex = SORT_DIC.indexOf(a['item'])
        let bIndex = SORT_DIC.indexOf(b['item'])
        if (aIndex === -1) {
          aIndex = Number.MAX_VALUE
        }
        if (bIndex === -1) {
          bIndex = Number.MAX_VALUE
        }
        return aIndex - bIndex
      })
      .map(value => {
        return value['item'].toUpperCase()
      })

    sorted = tmp.concat()

    ext = sorted.slice(0, len).join(join)
  }

  return ext
})
